export const HEADER_DESKTOP_HEIGHT = 80;
export const BLOCK_WITH_SELECTORS_HEIGHT_MOBILE = 44;
export const MENU_HEIGHT_MOBILE = 76;
export const TOP_SCROLL_TOLERANCE = 1;
export const BREACKPOINT_DESKTOP_MIN = 1024;
